import { render, staticRenderFns } from "./RelatorioCategoriasTotais.vue?vue&type=template&id=3fb9b6fa"
import script from "./RelatorioCategoriasTotais.vue?vue&type=script&lang=js"
export * from "./RelatorioCategoriasTotais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports